/**
 * Scales a mm size so it fits a printed A4 page.
 */
export const scaleMmToFitPage = (size: number) => `${270 / 210 * size}mm`;
